import React, { useState } from "react";
import { Container, Row, Col, Button, Breadcrumb } from "react-bootstrap";
import {
  FiHome,
  FiUser,
  FiClock,
  FiPlus,
  FiChevronsUp,
} from "react-icons/fi";

import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import TicketCards from "../../../components/Dashboard/help-desk-dshboard/TicketCards";
import TicketTrends from "../../../components/Dashboard/help-desk-dshboard/TicketTrends";
import TicketStatus from "../../../components/Dashboard/help-desk-dshboard/TicketStatus";
import SLACompliance from "../../../components/Dashboard/help-desk-dshboard/SLACompliance";
import TicketsCategory from "../../../components/Dashboard/help-desk-dshboard/TicketsCategory";
import BacklogGrowth from "../../../components/Dashboard/help-desk-dshboard/BacklogGrowth";
import AgentPerformance from "../../../components/Dashboard/help-desk-dshboard/AgentPerformance";
import ActivityItem from "../../../components/Dashboard/help-desk-dshboard/ActivityItem";
import CreateTicketModal from "../../../components/modals/help-desk-dashboard/CreateTicketModal";
import CloseTicketModal from "../../../components/modals/help-desk-dashboard/CloseTicketModal";

export default function HelpDeskDashboardPage() {
    const [showModal, setShowModal] = useState(false);
      const [showClose, setShowClose] = useState(false);
  return (
    <div style={styles.wrapper}>
      <Container fluid>

        <Row className="align-items-center justify-content-between">

          {/* LEFT SECTION */}
     <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Help Desk Dashboard</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                   <Link  to="/"  >
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        />
                   </Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                       Dashboard
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Help Desk Dashboard</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

          {/* RIGHT SECTION */}
          <Col
            md={6}
            xs={12}
            style={styles.right}
            className="d-flex flex-wrap justify-content-md-end"
          >
            {/* Assign Agent */}
            <Button style={styles.whiteBtn}>
              <FiUser style={styles.btnIcon} />
              Assign Agent
            </Button>

            {/* Close Ticket */}
            <Button        onClick={() => setShowClose(true)} style={styles.darkBtn}>
              <FiClock style={styles.btnIcon} />
              Close Ticket
            </Button>

            {/* Create Ticket */}
            <Button  onClick={() => setShowModal(true)} style={styles.orangeBtn}>
              <FiPlus style={styles.btnIcon} />
              Create Ticket
            </Button>

            {/* Collapse */}

            {/* <div style={styles.iconBox}>
              <FiChevronsUp />
            </div> */}
          </Col>

        </Row>


        <Row className="" >
          <TicketCards/>
        </Row>

            <Row className="g-3 mt-3">

      <Col xxl={6} lg={12} style={styles.responsiveCol}>
        <TicketTrends />
      </Col>

      <Col xxl={6} lg={12} style={styles.responsiveCol}>
        <TicketStatus />
      </Col>

    </Row>


<Row  className="mt-2" >
        <Col lg={4} md={12} style={{ marginTop: 20 }}>
          <SLACompliance/>
        </Col>

        <Col lg={4} md={12} style={{ marginTop: 20 }}>
          <BacklogGrowth />
        </Col>

        <Col lg={4} md={12} style={{ marginTop: 20 }}>
          <TicketsCategory />
        </Col>
      </Row>

<Row  className="mt-2" >
        <Col lg={8} md={9} style={{ marginTop: 20 }}>
          <AgentPerformance/>
        </Col>

        <Col lg={4} md={12} style={{ marginTop: 20 }}>
          <ActivityItem/>
        </Col>

      
      </Row>
      </Container>
          <CreateTicketModal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
            <CloseTicketModal
        show={showClose}
        handleClose={() => setShowClose(false)}
      />
    </div>
  );
}

/* EXACT STYLES */
const styles = {
  wrapper: {
    background: "#f8f9fb",
    padding: "15px 14px",
//     borderBottom: "2px solid #e5e7eb",
  },

  left: {
    marginBottom: "10px",
  },

  title: {
    fontSize: "22px",
    fontWeight: 600,
    marginBottom: 5,
    color: "#1f2937",
  },

  breadcrumb: {
    fontSize: "13px",
    marginBottom: 0,
    alignItems: "center",
  },

  homeIcon: {
    fontSize: 14,
  },

  breadText: {
    color: "#6b7280",
  },

  activeText: {
    color: "#111827",
    fontWeight: 500,
  },

  right: {
    gap: "8px",
    alignItems: "center",
  },

  btnIcon: {
    marginRight: 6,
  },

  whiteBtn: {
    background: "#fff",
    border: "1px solid #e5e7eb",
    color: "#111827",
    fontSize: 14,
    padding: "7px 13px",
    borderRadius: 4,
  },

  darkBtn: {
    background: "#0f3d3e",
    border: "none",
    color: "#fff",
    fontSize: 14,
    padding: "7px 13px",
    borderRadius: 4,
  },

  orangeBtn: {
    background: "#ff5a1f",
    border: "none",
    color: "#fff",
    fontSize: 14,
    padding: "7px 13px",
    borderRadius: 4,
  },

  iconBox: {
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: "6px 8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
};